module.exports = __webpack_public_path__ + "953d102dd657efd7be1e8d27559aadd5.svg";